import React from 'react';
import clsx from 'clsx';
import * as PropTypes from 'prop-types';

import useStyles from './styles';

const Tag = (props) => {
    const { name, onClick, selected, disabled } = props;
    const classes = useStyles(props);

    const clickable = !disabled && onClick;
    return (
        <button
            type="button"
            className={clsx(classes.root, {
                [classes.selected]: selected,
                [classes.disabled]: disabled,
                [classes.clickable]: clickable,
            })}
            {...(clickable ? { onClick } : {})}
        >
            {name}
        </button>
    );
};

Tag.defaultProps = {
    onClick: undefined,
    selected: false,
    disabled: false,
};

Tag.propTypes = {
    name: PropTypes.string.isRequired,
    onClick: PropTypes.func,
    selected: PropTypes.bool,
    disabled: PropTypes.bool,
};

export default Tag;
